<template>
    <b-row>
       <b-col md="12" class="mt-3">
           <b-card>
               <div slot="header">
           <b-row>
               <b-col>
                <strong> {{ documenttype && dashboardlabelobj[documenttype] ? dashboardlabelobj[documenttype] : '' }} Dashboard</strong> 
               </b-col>
               
           </b-row>
           

       </div>
           <div>
               <b-row>
         
                   <b-col sm="12" class="text-right  " >
               <a :href="loadurl" target="_blank" class="ml-3">
                   <b-button variant="primary"  size="md" @click="downlaodloadurl">Download</b-button>
               </a>
           </b-col>
              
               </b-row> 
           </div>

          

           <div class="text-right">
               <b>Total Records : <strong style="color: red;">{{totalRows}}</strong></b>
           </div>
           
          
           <b-table show-empty responsive :busy="isBusy" :items="attendancedatarows" :fields="fields"  :bordered="bordered"    :filter="filter"   :sort-by.sync="sortBy"  :sort-desc.sync="sortDesc"   :sort-direction="sortDirection"  @filtered="onFiltered" style="overflow-x: auto !important;"> 

               <div slot="table-busy" class="text-center text-danger my-2">
                 <b-spinner class="align-middle">
                 </b-spinner>
                 <strong>Loading...</strong>
               </div> 
             
               <template slot="ebnexpirydate" slot-scope="row">
                   <div>
                       {{ row.item.ebnexpirydate | ConvertTime12hour() }}
                   </div>
               </template>
           </b-table>
           
           <paginate class="pt-2"
  
               :page-count="noofpages"
               :page-range="10"
               :margin-pages="2"
               :click-handler="clickCallback"
               :prev-text="'Prev'"
               :next-text="'Next'"
               :container-class="'pagination'"
               :page-class="'page-item'">
           </paginate>

           </b-card>
       </b-col>

   </b-row>

</template>

<script>
import CONSTANTS from '@/utils/constants'
import Utils from '@/utils'
import Vue from 'vue'
export default {
data() {
   return {
       isBusy: false, 
       
       fields :[],
       EBN_expriryCount :[],
       attendancedatarows:[],
       isBusy : false,
       noofpages:'',
       pageNum:1,
       searching :[],
       searchvaluesarr:[],
       totalRows :0,
       CheckLoadID :[],
       SelectLoadID :[],
       selectDateFrom: '',
       route_id : null,
       isCheckAll: false,
       documenttype:'',
       hubname:'',
       shift:'',
       shiftstart:'',
       shiftend:'',
       loadurl :'',
       typelist : ['attendance','overtimestatus','singlepunch','latelogin','breaktimeexceeted'],
       User_type:null,
       rbhubid:null,
       dashboardlabelobj:{"overtimestatus":"OverTime Status","breaktimeexceeted":"Break Time Exceeded Hub-wise","latelogin":"Late Login Hub-wise","singlepunch":"Single Punch Hub-wise","attendance":"Attendance"}
   }
},

created() {
   var userdata = localStorage.getItem("userData");
   var userInfo = JSON.parse(userdata);
   this.User_type = userInfo.user_type;
   this.rbhubid = userInfo.hub_id
   console.log("userInfo", userInfo);
   this.route_id = this.$route.params.id;
   this.documenttype = this.$route.params.type
   this.hubid = this.$route.params.hubid
   this.shift = this.$route.params.shift
   this.shiftstart = this.$route.params.shiftstart
   this.shiftend = this.$route.params.shiftend 
 
   //console.log("this.route_id",this.route_id)
   this.attendancerecordlist(this.pageNum);
   // this.manuallyUpdateRecord();
 
},
mounted(){
  // this.attendancerecordlist()
},
methods: {
   checklenght(value){
       console.log("value",value)
       if (value.length==0) {
       this.searching=[]
       this.totalRows=0
       this.searchvaluesarr=[]
       this.attendancerecordlist(this.pageNum)
       }
   },

   clickCallback(pageNum){

       this.attendancerecordlist(pageNum);
   },
   attendancerecordlist : function(pageNo){     
       
      this.isBusy=true;

      if(this.typelist.includes(this.documenttype)){

       this.fields=[
               { key: 'hubid', label : 'HUB ID', sortable: true},
               { key: 'hubname', label : 'HUB NAME', sortable: true},
               { key: 'firstname', label : 'FIRST NAME', sortable: true},
               { key: 'lastname', label : 'LAST NAME', sortable: true},
               { key: 'contactnumber', label : 'CONTACT NUMBER', sortable: true},
               { key: 'date', label : 'DATE', sortable: true},
               { key: 'shiftname', label : 'Shift Name', sortable: true},
               { key: 'shifttime', label : 'Shift Time', sortable: true},
               { key: 'punchedinat', label : 'Punched_in_At', sortable: true},
               { key: 'punchedoutat', label : 'Punched_out', sortable: true},
               { key: 'extra_hours', label : 'Extra_Hours', sortable: true},
               { key: 'deficit_hours', label : 'Deficit_Hours', sortable: true},
               { key: 'attendance_remark', label : 'Attendance_Remark', sortable: true},
               { key: 'overtimestart', label : 'Overtime_Start', sortable: true},
               { key: 'overtimeend', label : 'Overtime_End', sortable: true},

               { key: 'overtimedurationinseconds', label : 'Total_Overtime', sortable: true},
               { key: 'Break_1_Start', label : 'Break_1_Start', sortable: true},
               { key: 'Break_1_End', label : 'Break_1_End', sortable: true},
           
               { key: 'Break_1_Time', label : 'Break_1_Time', sortable: true},

             
               { key: 'Break_2_Start', label : 'Break_2_Start', sortable: true},
               { key: 'Break_2_End', label : 'Break_2_End', sortable: true},
                
               { key: 'Break_2_Time', label : 'Break_2_Time', sortable: true},
               { key: 'Break_3_Start', label : 'Break_3_Start', sortable: true},
               { key: 'Break_3_End', label : 'Break_3_End', sortable: true},

               { key: 'Break_3_Time', label : 'Break_3_Time', sortable: true},

               { key: 'totalbreakdurationinseconds', label : 'Total_Break_Duration', sortable: true},
               { key: 'breakexceeded', label : 'Break_Exceeded', sortable: true},

               { key: 'status', label : 'Attendace_Status', sortable: true},

               { key: 'total_login_time', label : 'Total_Login_Time', sortable: true},
               { key: 'employeeid', label : 'Emp_id', sortable: true},


           ]
       
       var Obj = {       
           page_no:`${pageNo}`,
           startdate : this.shiftstart,
           enddate : this.shiftend,
           shift : this.shift,
           hubid : this.hubid.toLowerCase(),
           type: this.documenttype,
           hubrbid : this.User_type && this.User_type.toString() == '2' ? this.rbhubid.toString() : ''

       };
        this.$http.post(`${ CONSTANTS.MIGRATION_API_URL}/getattendancedatareport`,Obj)
       .then(result => {
           console.log("result",result)
           this.isBusy=false;
           if (result.body.returnmsg === "successful") {
               let v = result.body.returnvalue

                           
               
                   const updatedArray = v.map(obj => {

                    let breaktimestart = []
                   if(obj.breakstart!=null && obj.breakstart!=undefined && obj.breakstart!=''){
                    breaktimestart = obj.breakstart.includes(',') ? obj.breakstart.split(',') : [obj.breakstart]
                    }

                    let breaktimeend = []
                   if(obj.breakstart!=null && obj.breakstart!=undefined && obj.breakstart!=''){         
                    breaktimeend = obj.breakend.includes(',') ? obj.breakend.split(',') : [obj.breakend]
                    }

                        for(let i=0;i<breaktimestart.length;i++){
                            obj[`Break_${i+1}_Start`] = breaktimestart[i];
                        }

                        for(let i=0;i<breaktimeend.length;i++){
                            obj[`Break_${i+1}_End`] = breaktimeend[i];
                        }


                        if(obj.hasOwnProperty('Break_1_Start') && obj.hasOwnProperty('Break_1_End') && obj.Break_1_Start!='' && obj.Break_1_Start!=null && obj.Break_1_Start!=undefined && obj.Break_1_End!='' && obj.Break_1_End!=null && obj.Break_1_End!=undefined ){

                            obj['Break_1_Time'] = this.getsumtwodates(obj.Break_1_Start,obj.Break_1_End)

                        }

                        if(obj.hasOwnProperty('Break_2_Start') && obj.hasOwnProperty('Break_2_End') && obj.Break_2_Start!='' && obj.Break_2_Start!=null && obj.Break_2_Start!=undefined && obj.Break_2_End!='' && obj.Break_2_End!=null && obj.Break_2_End!=undefined ){

                        obj['Break_2_Time'] = this.getsumtwodates(obj.Break_2_Start,obj.Break_2_End)

                        }


                        if(obj.hasOwnProperty('Break_3_Start') && obj.hasOwnProperty('Break_3_End') && obj.Break_3_Start!='' && obj.Break_3_Start!=null && obj.Break_3_Start!=undefined && obj.Break_3_End!='' && obj.Break_3_End!=null && obj.Break_3_End!=undefined ){

                        obj['Break_3_Time'] = this.getsumtwodates(obj.Break_3_Start,obj.Break_3_End)

                        }   

                        let ototalbreakdurationinseconds =obj.totalbreakdurationinseconds ? obj.totalbreakdurationinseconds : null

                      
                        if(obj.totalbreakdurationinseconds!=null && obj.totalbreakdurationinseconds!='' && obj.totalbreakdurationinseconds!=undefined){
                        obj['totalbreakdurationinseconds'] = this.formatTime(obj.totalbreakdurationinseconds)
                        }

                        if(obj.overtimedurationinseconds!=null && obj.overtimedurationinseconds!='' && obj.overtimedurationinseconds!=undefined){
                        obj['overtimedurationinseconds'] = this.formatTime(obj.overtimedurationinseconds)
                        }

                        obj['total_login_time'] = '-'
                        obj['extra_hours'] = '00:00:00'
                        obj['deficit_hours'] = '00:00:00'
                        obj['attendance_remark'] = '-'
                        if(obj.punchedinat && obj.punchedoutat && ototalbreakdurationinseconds){
                            
                           obj['total_login_time']  = this.subtracttwodates(obj.punchedinat,obj.punchedoutat,ototalbreakdurationinseconds)

                            let mhours = this.calculateTimeDifference('08:00:00',obj['total_login_time'])

                            obj['extra_hours'] = mhours.sign == 'negative' ? mhours.timeFormat : '00:00:00'
                            obj['deficit_hours'] = mhours.sign == 'positive' ? mhours.timeFormat : '00:00:00'
                            
                            obj['attendance_remark'] = mhours.sign == 'negative' ? 'Extra Hrs' : 'Deficit Hrs'

                        }

                        if(obj.punchedinat && obj.punchedoutat && !ototalbreakdurationinseconds){
                            
                            obj['total_login_time']  = this.getsumtwodates(obj.punchedinat,obj.punchedoutat)
 
                             let mhours = this.calculateTimeDifference('08:00:00',obj['total_login_time'])
 
                             obj['extra_hours'] = mhours.sign == 'negative' ? mhours.timeFormat : '00:00:00'
                             obj['deficit_hours'] = mhours.sign == 'positive' ? mhours.timeFormat : '00:00:00'
                             
                             obj['attendance_remark'] = mhours.sign == 'negative' ? 'Extra Hrs' : 'Deficit Hrs'
 
                         }
                        
                        if(obj.punchedinat && obj.punchedinat!='' && obj.punchedinat !=undefined){
                            obj['punchedinat'] = this.getCurrentTimestamp(obj.punchedinat)
                        }

                        if(obj.punchedoutat && obj.punchedoutat!='' && obj.punchedoutat !=undefined){
                            obj['punchedoutat'] = this.getCurrentTimestamp(obj.punchedoutat)
                        }

                        if(obj.overtimestart && obj.overtimestart!='' && obj.overtimestart !=undefined){
                            obj['overtimestart'] = this.getCurrentTimestamp(obj.overtimestart)
                        }

                        if(obj.overtimeend && obj.overtimeend!='' && obj.overtimeend !=undefined){
                            obj['overtimeend'] = this.getCurrentTimestamp(obj.overtimeend)
                        }

                        
                    let emailid = obj.createdby.split('@')
                   
                   let getfullname = emailid[0].split('.')

                   let firstname = getfullname[0] ? getfullname[0] :''
                   let lastname = getfullname[1] ? getfullname[1] : ''
                   
                   let shifttime = obj.attendance_starttime +'-'+ obj.attendance_endtime
                   return {...obj, firstname: firstname,lastname:lastname,shifttime:shifttime};
                   });
                   this.attendancedatarows = updatedArray
                   this.totalRows = result.body.rowcount

                   this.noofpages=parseInt(this.totalRows)/20;
                   this.noofpages=Math.ceil(this.noofpages);

           }else{
               this.attendancedatarows = []
               this.totalRows = 0
            //   this.EBN_expriryCount=[];
           }
       }).catch(ex => {
           console.log("error", ex);
       });
   }
   },
   downlaodloadurl(){
 //  var userdata = localStorage.getItem("userData");
   //var userInfo = JSON.parse(userdata);
   let rbhubid = this.User_type && this.User_type.toString() == '2' ? this.rbhubid.toString() : ''
   this.loadurl=`${CONSTANTS.MIGRATION_API_URL}/getCSVattendancedata?hubid=`+this.hubid.toLowerCase()+`&startdate=`+this.shiftstart+`&enddate=`+this.shiftend+`&shift=`+this.shift+`&type=`+this.documenttype+`&hubrbid=`+rbhubid+` `
   console.log("this.loadurl",this.loadurl)
 },
 formatTime(seconds) {
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const secs = seconds % 60;

   const formattedHours = String(hours).padStart(2, '0');
  const formattedMinutes = String(minutes).padStart(2, '0');
  const formattedSeconds = String(secs).padStart(2, '0');

  return `${formattedHours}:${formattedMinutes}:${formattedSeconds}`;
},
subtracttwodates(date1,date2,oseconds){
    const timestamp1 = new Date(date1);
const timestamp2 = new Date(date2);
 const differenceInMilliseconds = timestamp2 - timestamp1;

 const millisecondsToSubtract = oseconds * 1000;

 const newDifferenceInMilliseconds = differenceInMilliseconds - millisecondsToSubtract;

 const newTotalSeconds = Math.floor(newDifferenceInMilliseconds / 1000);

 const newHours = Math.floor(newTotalSeconds / 3600);
const newMinutes = Math.floor((newTotalSeconds % 3600) / 60);
const newSeconds = newTotalSeconds % 60;

 const pad = num => String(num).padStart(2, '0');

 const newFormattedTimeDifference = `${pad(newHours)}:${pad(newMinutes)}:${pad(newSeconds)}`;

    return newFormattedTimeDifference

},
calculateTimeDifference(time1, time2) {
     const [h1, m1, s1] = time1.split(':').map(Number);
    const [h2, m2, s2] = time2.split(':').map(Number);

     const date1 = new Date(2024, 0, 1, h1, m1, s1);
    const date2 = new Date(2024, 0, 1, h2, m2, s2);

     const difference = date1 - date2;
  
    const absDifference = Math.abs(difference);
    const diffDate = new Date(absDifference);

    const hours = diffDate.getUTCHours().toString().padStart(2, '0');
    const minutes = diffDate.getUTCMinutes().toString().padStart(2, '0');
    const seconds = diffDate.getUTCSeconds().toString().padStart(2, '0');
  
  const isPositive = difference >= 0;
    const formattedTime = `${hours}:${minutes}:${seconds}`;
    
    return {
        timeFormat: formattedTime,
        sign: isPositive ? 'positive' : 'negative'
    };
 
},
formatDateComponent(value) {
    return value < 10 ? `0${value}` : value;
},
getCurrentTimestamp(odate) {
    const now = new Date(odate);
    
    const year = now.getFullYear();
    const month = this.formatDateComponent(now.getMonth() + 1); // Months are 0-based
    const day = this.formatDateComponent(now.getDate());
    const hours = this.formatDateComponent(now.getHours());
    const minutes = this.formatDateComponent(now.getMinutes());
    const seconds = this.formatDateComponent(now.getSeconds());
    
    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
},
getsumtwodates(date1,date2){
    const timestamp1 = new Date(date1);
const timestamp2 = new Date(date2);
 const differenceInMilliseconds = timestamp2 - timestamp1;

 
 const newDifferenceInMilliseconds = differenceInMilliseconds  

 const newTotalSeconds = Math.floor(newDifferenceInMilliseconds / 1000);

 const newHours = Math.floor(newTotalSeconds / 3600);
const newMinutes = Math.floor((newTotalSeconds % 3600) / 60);
const newSeconds = newTotalSeconds % 60;

 const pad = num => String(num).padStart(2, '0');

 const newFormattedTimeDifference = `${pad(newHours)}:${pad(newMinutes)}:${pad(newSeconds)}`;

    return newFormattedTimeDifference
}


},
computed: {
//   rows() {
//     return this.EBN_expriryCount.length
//   }
},
}
</script>